import React, { useEffect, useState } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { isMobileDevice } from '../../../common/utilities/utils';
import Modal from '../../../molecules/Modal';
import ImageComponent from 'atoms/Image/index';
import { GIFTCARD_CONSTANTS } from '../Constants/giftcardConstants';
import isEmpty from 'lodash/isEmpty';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const SuccessfulPurchase = props => {
  const { PURCHASESUCCESS_MODAL, PURCHASEFAILURE_MODAL, PAYMENT_FAILED_MESSAGE } = GIFTCARD_CONSTANTS;
  const { isOpen, handleClose, purchaseStatus, paymentStatus } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const { GiftcardSuccessImg, GiftCardFailureImg } = IMAGE_PATH;
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const redirectHandler = () => {
    handleClose();
  };

  const modalProps = isMobile
    ? {
        role: 'dialog',
        modalTitleId: 'PurchaseSuccesspopup',
        show: isOpen,
        classNames: 'giftcard-purchase-success',
        showCloseBtn: true,
        closeButtonHandler: handleClose,
        autoFocus: true,
        modalTitle: ' ',
        closeDataTestId: 'purchase-success',
      }
    : {
        role: 'dialog',
        modalTitleId: 'PurchaseSuccesspopup',
        show: isOpen,
        classNames: 'giftcard-purchase-success',
        showCloseBtn: true,
        showBackBtn: false,
        closeButtonHandler: handleClose,
        modalTitle: ' ',
        autoFocus: true,
        closeDataTestId: 'purchase-success',
      };

  return (
    <div className={`giftcardContainer${isMobile ? ' mobile' : ''}`} data-testid='giftcard-success'>
      {isOpen && (
        <>
          {!isEmpty(purchaseStatus) && (
            <Modal {...modalProps}>
              {purchaseStatus === 'success' ? (
                <div className='giftCardSuccessContent'>
                  <div className='imageComp'>
                    <ImageComponent srcFile={GiftcardSuccessImg} alt={'giftcard'} className='giftcard-confirm' />
                  </div>
                  <div className='congratsMsg'>{translateWithI18Next(PURCHASESUCCESS_MODAL.CONGRATS_TEXT)}</div>
                  <div className='feedbackMsg'>{translateWithI18Next(PURCHASESUCCESS_MODAL.FEEDBACK_MESSAGE)}</div>
                  <div className='buttonTobuy'>
                    <button data-testid='buy-card' className='button whiteButton blackBorder' onClick={redirectHandler}>
                      {translateWithI18Next(PURCHASESUCCESS_MODAL.BUY_NEWGIFTCARD)}
                    </button>
                  </div>
                </div>
              ) : (
                <div className='giftCardSuccessContent'>
                  <div className='imageComp'>
                    <ImageComponent srcFile={GiftCardFailureImg} alt={'giftcardfailure'} className='giftcard-confirm' />
                  </div>
                  <div className='congratsMsg'>{translateWithI18Next(PURCHASEFAILURE_MODAL.FAILURE_TEXT)}</div>
                  {(paymentStatus === 'Failed' && (
                    <div className='feedbackMsg'>{translateWithI18Next(PAYMENT_FAILED_MESSAGE)}</div>
                  )) || (
                    <div className='feedbackMsg'>{translateWithI18Next(PURCHASEFAILURE_MODAL.FAILURE_MESSAGE)}</div>
                  )}
                  <div className='buttonTobuy'>
                    <button data-testid='reset' className='button whiteButton blackBorder' onClick={redirectHandler}>
                      {translateWithI18Next(PURCHASEFAILURE_MODAL.RETRY)}
                    </button>
                  </div>
                </div>
              )}
            </Modal>
          )}
        </>
      )}
    </div>
  );
};

export default SuccessfulPurchase;
